export const formatEnum = (value: any) => {
  if (!value) {
    return '';
  }

  return (
    String(value)
      // UserName / userName -> User Name
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      // USER_NAME -> USER NAME
      .replace(/_/g, ' ')
      .toLowerCase()
      // user name -> User name
      .replace(/\b\w/g, (char) => char.toUpperCase())
  );
};
